import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 1,
        marginBottom: 10
    },
    agentdetailData: {
        color: '#000',
        fontSize: 10,
        fontFamily: 'Helvetica-Oblique',
        marginBottom: 5,
       
    },
  });


const AgentDetails = ({invoice}) =>{
    var invoice1 = (JSON.stringify(invoice));
   var invoice2 = JSON.parse(invoice1);
   var invoice3 = JSON.parse(invoice2);
   var agentdetails=  invoice3.agentdetails;
   
    return(
       <Fragment>
       <View style={styles.invoiceNoContainer}>
           <Text style={styles.agentdetailData}>Agent Name:- {agentdetails.first_name} {agentdetails.last_name}</Text>
           <Text  style={styles.agentdetailData}>Agent Company Name:-  {agentdetails.corporate_name}</Text>
           <Text  style={styles.agentdetailData}>Address:- {agentdetails.address} {agentdetails.city}, {agentdetails.island}, {agentdetails.agent_country} ({agentdetails.zip_code}) </Text>
           <Text  style={styles.agentdetailData}>Email:- {agentdetails.email}</Text>
           <Text  style={styles.agentdetailData}>Mobile Number:- {agentdetails.country_code}-{agentdetails.mobile_number}</Text>
       </View >
      
    </Fragment>
      );
 
   } 
  
  export default AgentDetails